export interface ElementOffset {
  left: number;
  top: number; 
}

export function getOffset(element: HTMLElement | undefined): ElementOffset | undefined {
  if (!element) {
    return;
  }
  const bodyRect = document.body.getBoundingClientRect(),
        elemRect = element.getBoundingClientRect();
  return {
    left: elemRect.left - bodyRect.left,
    top: elemRect.top - bodyRect.top,
  };
}